import {Component, ContentChild, ElementRef, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cmp-modal',
  template: `<div (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'show': visibleAnimate}"
     [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}">
  <div class="modal-dialog">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>


`,
  styles: [`.modal{background:rgba(0,0,0,.6)}:host ::ng-deep .modal-dialog{overflow-y:initial!important}`]

})
export class ModalComponent {

  @ContentChild('cmpModalHeader') cmpModalHeader: ElementRef;
  @ContentChild('cmpModalBody') cmpModalBody: ElementRef;
  @ContentChild('cmpModalFooter') cmpModalFooter: ElementRef

  public visible = false;
  public visibleAnimate = false;

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}
